import { render } from "./EditObjectDescrModal.vue?vue&type=template&id=a3e7a88e"
import script from "./EditObjectDescrModal.vue?vue&type=script&lang=js"
export * from "./EditObjectDescrModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__